<div style="flex-direction: column;">
    <div style="display: flex; flex-direction: row;">
        <div class="project-details-wrapper">
            <mat-drawer-container class="project-details-drawer-container">
                <mat-drawer mode="side" class="project-details-drawer" [opened]="isDrawerOpen">
                    <mat-card class="project-details-card-maindata">
                        <mat-card-header style="justify-content: center;">
                            <h1>Stammdaten</h1>
                        </mat-card-header>
                        <mat-card-content>
                                <div class="project-details-cardspace">
                                    <b>Projektnummer</b>
                                    <mat-chip>{{projectDataViewModel()?.contractNr}}</mat-chip>
                                </div>
                                <div class="project-details-cardspace">
                                    <b>Phase</b>
                                    <mat-chip>{{projectDataViewModel()?.phase}}</mat-chip>
                                </div>
                                <div class="project-details-cardspace">
                                    <b>Bezeichnung</b>
                                    <mat-chip>{{projectDataViewModel()?.displayName}}</mat-chip>
                                </div>
                                <div class="project-details-cardspace">
                                    <b>vertragführender Fachbereich</b>
                                    <mat-chip>{{projectDataViewModel()?.departmentName}}</mat-chip>
                                </div>
                        </mat-card-content>
                    </mat-card>
                </mat-drawer>
                <mat-drawer-content>
                <mat-card class="project-details-card-checks" appearance="outlined">
                    <mat-card-header class="controls-header">
                        <button matButton="outlined" style="align-self: flex-start;" (click)="openDialog()">Neue Kontrolle</button>
                        <h1> Kontrollen</h1>
                    </mat-card-header>
                    <mat-card-content>
                        <app-all-checks
                            [usersById]="usersById()"
                            [projectsById]="projectsById()"
                            [projectCode]="projectCode()"
                            [newCheckId]="newCheckId()"
                        />
                    </mat-card-content>
                </mat-card>
                </mat-drawer-content>
            </mat-drawer-container>
        </div>
    </div>
</div>
